// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__PyCps","containerFormAndData":"Contact_containerFormAndData__ULoIG"};